import { Component } from "react";
import '../output-records-style/output-records.style.css';
import Icon from '../../../../icon';
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";
import { httpDownload } from "../../../../../utils/api.utils";
import { Loading } from "../../../../common/loading";
import { convertToFormatLocalDate } from "../../../../../utils/helpers.utils";
import { connect } from "react-redux";
import { TRANSLATIONS as translation } from "../../../../../utils/constant.utils";


class OutputRecordsInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadingFile: null,
        };
    }
  
    handleOnClickFile = async (filePath, fileName, key) => {
        if (this.state.downloadingFile) {
            return;
        }
       
        if (window.confirm(MODAL_CUSTOM_MESSAGE.export_alert_message)) {
            if(filePath) {
                try {
                    this.setState({ downloadingFile: key });

                    await httpDownload('common/fileAttachment/downloadFileViaURL', filePath)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(`Failed to download file: ${response.statusText}`);
                            }
                            return response.blob();
                        })
                        .then(blob => {
                            let downloadUrl = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(blob, fileName);
                            } else if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                            }
                            window.URL.revokeObjectURL(downloadUrl);
                        });
                } catch (error) {
                    console.error('Download failed:', error);
                    alert('Failed to download file.');
                } finally {
                    this.setState({ downloadingFile: null });
                }
            }
        }
    }

    toLocaleLanguage = (key, isCapitalize=true) => {
                const { locale } = this.props;
                if (locale === null || locale === '')
                    return translation[translation['defaultLocaleLanguage']][key];
                
                return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
        }
    
    render() {
        const { recordData, isLoading, activeDateFormat } = this.props;
        const { downloadingFile } = this.state;

        if (isLoading) {
            return <Loading />;
        }

        return(
            <>
                <div className="p-4 row row-cols-1 row-cols-sm-2 gy-4 gx-5">
                    <div>
                        <span className="record-info__title">
                            {this.toLocaleLanguage("output_record_id")}
                        </span>
                        <p className="record-info__details">
                            {recordData?.OutputRecordID ? recordData.OutputRecordID : ''}
                        </p>
                    </div>
                    <div>
                        <span className="record-info__title">
                             {this.toLocaleLanguage("configuration_name")}
                        </span>
                        <p className="record-info__details">
                            {recordData?.ConfigurationName ? recordData.ConfigurationName : ''}
                        </p>
                    </div>
                    <div>
                        <span className="record-info__title">
                            {this.toLocaleLanguage("creation_date")}
                        </span>
                        <p className="record-info__details">
                            {recordData?.CreatedDateStr ? recordData.CreatedDateStr : ''}
                        </p>
                    </div>
                    <div>
                        <span className="record-info__title">
                            {this.toLocaleLanguage("created_by")}
                        </span>
                        <p className="record-info__details">
                            {recordData?.CreatedBy ? recordData.CreatedBy : ''}
                        </p>
                    </div>
                </div>
                {
                    recordData?.GeneratedFiles.length > 0 &&
                    <div className="px-4 pt-2 pb-4">
                        <span className="record-info__title">{this.toLocaleLanguage("generated_files")}</span>
                        <div className="record-file__list">
                            <ul className="custom-divider">
                                {recordData.GeneratedFiles.map((file, index) => {
                                    const isDownloading = downloadingFile === file.key;

                                    return (
                                        <li key={index} onClick={() => { this.handleOnClickFile(file.filePath, file.name, file.key) }} className="d-flex justify-content-between align-items-center p-2">
                                            <div className="d-flex align-items-center gap-3 min-w-0 w-100">
                                                <Icon
                                                    customClassName="icon-line"
                                                    name="file-lines-solid"
                                                    size="19px"
                                                    containerClass="record-icon-container"
                                                />
                                                <span className="file-list__name">{file.name}</span>
                                                <div className="d-flex align-items-center gap-2">
                                                    {
                                                        isDownloading ?
                                                            <div className="spinner-border spinner-border-sm" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        :
                                                            <Icon
                                                                customClassName="icon-line"
                                                                name="arrow-download"
                                                                size="19px"
                                                                containerClass="record-icon-container"
                                                            />
                                                    }                                    
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default connect(
        state =>{
            const { activeDateFormat } = state.adminSetting;
            const { translation } = state;
            return {
                ...translation,
                activeDateFormat
            };
        }
)(OutputRecordsInfo);